import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
type paths = import('../__api/_apiConfig/api-types').paths;

type TableDataResponse = paths['/v1/data/{tableName}']['get']['responses']['200']['content']['application/json'];

@Injectable({
  providedIn: 'root'
})
export class DependencyService {

  apiUrl = 'https://dashboard.voyjaleas.com/api-dashboard/get/'; // ✅ Replace with your real API URL
  loading = false;
  private base = 'https://api.voyjaleas.com';
  
  constructor(private http: HttpClient) {}

  headers(client: 'website'|'dashboard'|'webapp'|'landing', apiKey?: string) {
      const h: Record<string,string> = { 'X-Client': client };
      if (apiKey) h['X-API-Key'] = apiKey;
      return new HttpHeaders(h);
  }

  // Generic GET request with up to 4 optional params
  getBackendDataForQueryId(
    queryId: string,
    queryParam1?: string,
    queryParam2?: string,
    queryParam3?: string,
    queryParam4?: string
  ): Observable<any> {
    let params = new HttpParams().set('queryId', queryId);
    let config = {};
    config['fileName'] = 'queryHandler.php';
    let api = this.apiUrl + config['fileName'];

    if (queryParam1) params = params.set('queryParam1', queryParam1);
    if (queryParam2) params = params.set('queryParam2', queryParam2);
    if (queryParam3) params = params.set('queryParam3', queryParam3);
    if (queryParam4) params = params.set('queryParam4', queryParam4);
    
    return this.http.get(api, {
      params,
      withCredentials: true
    });
  }

  getXhr(queryId: string,queryParam1?: string,queryParam2?: string,queryParam3?: string,queryParam4?: string) : Observable<any>{
    let phpFileName = '';
    let api = '';
    let config = {};
    config['fileName'] = 'queryHandler.php';
    config['domain'] = 'dashboard.voyjaleas.com';
    config['apiUrl'] = 'api-dashboard';
    config['operation'] = 'get';
    config['xhrOp'] = "get";
    config['requestUrl'] = 'https://' + config['domain'] + '/' +  config['apiUrl'] + '/'+ config['operation']+'/';

    api  = this.apiUrl + config['requestUrl'];
    let queryParam = '?queryId=' + queryId;
    queryParam1 ? queryParam = queryParam + '&queryParam1=' + queryParam1 : queryParam = queryParam;
    queryParam2 ? queryParam = queryParam + '&queryParam2=' + queryParam2 : queryParam = queryParam;
    queryParam3 ? queryParam = queryParam + '&queryParam3=' + queryParam3 : queryParam = queryParam;
    queryParam4 ? queryParam = queryParam + '&queryParam4=' + queryParam4 : queryParam = queryParam;
    
    ///
    phpFileName = config['fileName'];
    // READY URL
    api = this.apiUrl + phpFileName + queryParam;

    return this.http.get(api, {
      withCredentials: true
    });
  }

  // GET all rows of a tableName
  getTableData(tableName,limit=20, offset=0, client:'website'|'dashboard'='website', apiKey?: string) {
    return this.http.get<TableDataResponse>(`${this.base}/v1/data/${tableName}`, { params: { limit: String(limit), offset: String(offset) }, headers: this.headers(client, apiKey) });
  }

}
